import PaymentAdminApi from './PaymentAdminApi';
export default PaymentAdminApi;